import { APPROVAL_TYPES } from "./constants";

const orderApprovalSelector = (state) => state.approval[APPROVAL_TYPES.order];
const paymentApprovalSelector = (state) => state.approval[APPROVAL_TYPES.payment];

export { orderApprovalSelector, paymentApprovalSelector };
